import { render } from "./StudyModeScreen.vue?vue&type=template&id=68523c58&scoped=true"
import script from "./StudyModeScreen.vue?vue&type=script&lang=js"
export * from "./StudyModeScreen.vue?vue&type=script&lang=js"

import "./StudyModeScreen.vue?vue&type=style&index=0&id=68523c58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68523c58"]])

export default __exports__